import e from "react";
import { View as n, Text as l, cx as d, Icon as v } from "@vectord/ui";
const o = ({
  className: t,
  title: r,
  iconComponent: a
}) => /* @__PURE__ */ e.createElement(n, { className: `vd-flex-col vd-justify-center ${t}` }, /* @__PURE__ */ e.createElement(l, { weight: "bold", color: "text-neutral-tertiary", fontSize: "b3" }, r), /* @__PURE__ */ e.createElement("hr", { className: "vd-border-border-neutral-subtlest" }), a), f = `
  vd-gap-x-16
  vd-flex-row vd-justify-between
  vd-px-16
`, x = `
  vd-bg-surface-neutral-elevate-lower vd-px-24 vd-py-16 vd-gap-x-16
`, u = "vd-p-8 vd-flex-col vd-gap-y-4 vd-items-center", b = ({
  leftTitle: t,
  rightTitle: r,
  metric: a,
  leftIconComponent: m,
  rightIconComponent: i,
  centerIconComponet: s,
  metricLabel: c,
  containerClass: E
}) => /* @__PURE__ */ e.createElement(n, { className: d(f, E) }, /* @__PURE__ */ e.createElement(
  o,
  {
    className: "vd-items-start",
    title: t,
    iconComponent: m
  }
), /* @__PURE__ */ e.createElement(n, { className: u }, c && /* @__PURE__ */ e.createElement(l, { color: "text-alert-success-soft", fontSize: "b3" }, c), a && /* @__PURE__ */ e.createElement(l, { color: "text-alert-success-strong", fontSize: "h1", weight: "bold" }, a, "%"), s || /* @__PURE__ */ e.createElement(v, { name: "flow-arrow", iconSize: "xl" })), /* @__PURE__ */ e.createElement(
  o,
  {
    className: "vd-items-end",
    title: r,
    iconComponent: i
  }
)), N = ({
  leftTitle: t,
  rightTitle: r,
  label: a,
  leftIconComponent: m,
  rightIconComponent: i,
  centerIconComponet: s,
  containerClass: c
}) => /* @__PURE__ */ e.createElement(n, { className: "vd-flex-col" }, /* @__PURE__ */ e.createElement(n, { className: d(x, c) }, /* @__PURE__ */ e.createElement(
  o,
  {
    className: "vd-items-start",
    title: t,
    iconComponent: m
  }
), /* @__PURE__ */ e.createElement(n, { className: u }, s || /* @__PURE__ */ e.createElement(v, { name: "flow-arrow", iconSize: "xl" })), /* @__PURE__ */ e.createElement(
  o,
  {
    className: "vd-items-end",
    title: r,
    iconComponent: i
  }
)), a && /* @__PURE__ */ e.createElement(n, { className: "vd-bg-background-alert-success-subtlest vd-py-8 vd-justify-center vd-items-center" }, /* @__PURE__ */ e.createElement(l, { fontSize: "b1", color: "text-alert-success-soft" }, a))), p = (t) => {
  switch (t.variant) {
    case "v1":
      return /* @__PURE__ */ e.createElement(b, { ...t });
    case "v2":
      return /* @__PURE__ */ e.createElement(N, { ...t });
    default:
      return /* @__PURE__ */ e.createElement(e.Fragment, null);
  }
};
export {
  p as default
};
